import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step15_Emprego: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.job) newErrors.job = 'Profissão/Ocupação é obrigatória';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ job: data.job });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="Você possui emprego fixo?">
      {/* <div className="mb-6">
        <p className="font-semibold mb-2">Você possui emprego fixo?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Nos diga qual é sua profissão ou ocupação atual. Isso ajuda a entender melhor sua estabilidade financeira.
        </p>
      </div> */}
      <FormFieldGroup
        label="Qual área você atua?"
        required
        error={errors.job}
      >
        <input
          type="text"
          placeholder="Descreva aqui.."
          value={data.job || ''}
          onChange={(e) => handleFieldChange('job', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step15_Emprego;
